import React from "react";

const ControlStudent = () => {
  return <text>ControlStudent</text>;
};

export default ControlStudent;
